import '../collection-action-menu/collection-action-menu.js';
import '../wishlist-collection-head/wishlist-collection-head.js';
import '../wishlist-image/wishlist-image.js';
import {css, CSSResult, html, LitElement, nothing, unsafeCSS} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {CollectionTrackingContext, Messages, Product, WishlistCollection} from '../../../@types/wishlist.js';
import {consume} from '@lit/context';
import {i18nContext} from '../../../scripts/context/i18nContext.js';
import {repeat} from 'lit/directives/repeat.js';
import typographyStyles from '../../../styles/responsive-nui-typography.scss';
import styles from './wishlist-collection.scss';
import {WishlistAppConfig, wishlistAppConfigContext} from '../../../scripts/context/appConfigContext.js';
import {productsContext} from '../../../scripts/context/wishlistContext.js';
import {ProductsState} from '../../../scripts/context/wishlist-state.js';

@customElement('ents-wishlist-collection')
export class UIWishlistCollection extends LitElement {
  @property({type: Object, attribute: 'wishlist-collection'})
  wishlistCollection!: WishlistCollection;

  @property({type: Boolean, attribute: 'show-share-icon', reflect: true})
  private showShareIcon: boolean = false;

  @consume({context: productsContext, subscribe: true})
  @property({attribute: false})
  private productsState!: ProductsState;

  @consume({context: i18nContext})
  private messages!: Messages;

  @consume({context: wishlistAppConfigContext})
  private wishlistAppConfig!: WishlistAppConfig;

  static get styles(): CSSResult[] {
    return [css`${unsafeCSS(styles)}`, css`${unsafeCSS(typographyStyles)}`];
  }

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  render() {
    const products = this.productsState.getProductsToRender(this.wishlistCollection.id);
    const collectionTrackingContext: CollectionTrackingContext = {
      productsAmount: products.length,
      eventContext: 'collection_list',
    };
    return html`
      <a
        class="ents-wishlist-list__link"
        href="${this.wishlistAppConfig.collectionEndpoint}${this.wishlistCollection.id}/"
      >
        <div data-test-ents-wishlist-collection="${this.wishlistCollection.id}" class="ents-wishlist-list">
          <ents-wishlist-collection-head
            .wishlistCollection="${this.wishlistCollection}"
            .collectionTrackingContext="${collectionTrackingContext}"
            ?show-share-icon="${this.showShareIcon}"
          >
          </ents-wishlist-collection-head>
          ${products.length > 0 ? this.renderProducts(products) : this.renderEmpty()}
        </div>
      </a>
    `;
  }

  private renderProducts(products: Product[]) {
    const showProducts = products.length > 5 ? products.slice(0, 4) : products.slice(0, 5);
    return html`
      <div class="ents-wishlist-list-preview-items">
        ${repeat(showProducts, p => p.syan, p => html`
          <ents-wishlist-image
            data-test-ents-wishlist-collection-picture="${p.syan}"
            image-url="${p.defaultImageUrls[0].url}"
            alt-text="${p.brandName} ${p.name}"
            ?is-beauty="${p.isBeauty}"
            brand-code="${p.brandCode}"
          ></ents-wishlist-image>
        `)}
        ${products.length > showProducts.length ? html`
          <div data-test-ents-wishlist-collection-more
               class="ents-wishlist-list-preview-items__more-hint ents-copy-bold"
          >
              +${products.length - showProducts.length}
          </div>
        ` : nothing}
      </div>
    `;
  }

  private renderEmpty() {
    return html`
      <div class="ents-copy ents-wishlist-list__empty-hint"
           data-test-ents-wishlist-collection-empty>
        <div class="ents-wishlist-list__empty-hint__link bdk-link-primary" size="mdium">
          ${this.messages['ents_wishlist_collection_details_link_text']}
        </div>
      </div>
    `;
  }
}
